
import React from "react";
import { Button } from "../../components/ui/button";
import { Download } from "lucide-react";

const ImportTemplate = () => {
  const downloadTemplate = () => {
    const csvContent = "civilité;prénom;nom;téléphone;téléphone_fixe;email;adresse;code postal;ville;département;région;profession;adeli_rpps;commentaire";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "modele_import_crm.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100">
      <h3 className="text-lg font-medium mb-4">Téléchargez un modèle</h3>
      <p className="text-gray-600 mb-4">
        Utilisez notre modèle CSV pour préparer votre fichier d&apos;import. Le modèle contient tous les champs supportés par le CRM.
      </p>
      <Button onClick={downloadTemplate} variant="outline" className="flex items-center gap-2">
        <Download className="h-4 w-4" />
        Télécharger le modèle CSV
      </Button>
    </div>
  );
};

export default ImportTemplate;
